import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { collection, doc, getDoc, getDocs, onSnapshot, query, where, writeBatch } from "firebase/firestore";
import { db } from "../../firebase";

const DEFAULT_ORG_ID = "wdWV2HZV88H2HGlqXrWa";
const palette = {
  text: "#17324A",
  soft: "#718497",
  line: "#E2E8EF",
  page: "#F5F7FA",
  white: "#FFFFFF",
  blue: "#2872A8",
  blueSoft: "#EDF5FB",
  orange: "#E87922",
  green: "#18764B",
  greenSoft: "#EAF7F0",
  red: "#B83E3E",
  redSoft: "#FFF1F0",
};

const DELIVERY_SCROLLBAR_CSS = `
.dmd-page-scroll {
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  scrollbar-gutter: stable;
  scrollbar-width: thin !important;
  scrollbar-color: #8F9EAA #E8EDF2 !important;
}
.dmd-page-scroll::-webkit-scrollbar {
  width: 12px;
}
.dmd-page-scroll::-webkit-scrollbar-track {
  border-radius: 999px;
  background: #E8EDF2;
}
.dmd-page-scroll::-webkit-scrollbar-thumb {
  border: 3px solid #E8EDF2;
  border-radius: 999px;
  background: #8F9EAA;
}
.dmd-page-scroll::-webkit-scrollbar-thumb:hover {
  background: #647789;
}
`;

const DELIVERY_DETAILS_CSS = `
.dmd-detail-stack{display:grid;gap:14px}
.dmd-detail-toolbar{display:flex;align-items:center;justify-content:space-between;gap:12px}
.dmd-detail-toolbar .dmd-back-button{margin:0}
.dmd-record-hint{color:#8593a1;font-size:11px;font-weight:750}
.dmd-overview-card,.dmd-panel,.dmd-progress-card{border:1px solid #e2e8ef;border-radius:16px;background:#fff;box-shadow:0 7px 22px rgba(15,35,55,.035)}
.dmd-overview-card{padding:20px 22px}
.dmd-overview-top{display:flex;align-items:flex-start;justify-content:space-between;gap:16px}
.dmd-eyebrow{color:#718497;font-size:11px;font-weight:850;letter-spacing:.04em}
.dmd-main-title{margin:5px 0 0;color:#17324a;font-size:23px;line-height:1.3;font-weight:900;overflow-wrap:anywhere}
.dmd-chip-row{display:flex;align-items:center;gap:7px;flex-wrap:wrap}
.dmd-chip{display:inline-flex;align-items:center;min-height:27px;padding:0 10px;border-radius:999px;background:#edf5fb;color:#2872a8;font-size:11px;font-weight:850;white-space:nowrap}
.dmd-chip-status{background:#fff4e8;color:#b85d1d}
.dmd-chip-status.is-good{background:#eaf7f0;color:#18764b}
.dmd-chip-status.is-error{background:#fff1f0;color:#b83e3e}
.dmd-recipient-line{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-top:17px;padding-top:15px;border-top:1px solid #edf0f3}
.dmd-recipient-main{min-width:0}
.dmd-meta-label{display:block;color:#8492a0;font-size:10px;font-weight:800}
.dmd-recipient-name{display:block;margin-top:4px;color:#17324a;font-size:15px;font-weight:850;overflow-wrap:anywhere}
.dmd-recipient-email{display:block;margin-top:3px;color:#2872a8;font-size:12px;font-weight:700;overflow-wrap:anywhere}
.dmd-company{flex:0 0 auto;max-width:40%;color:#718497;font-size:12px;font-weight:750;text-align:right;overflow-wrap:anywhere}
.dmd-overview-facts{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-top:15px}
.dmd-fact{min-width:0;padding:11px 12px;border-radius:10px;background:#f6f9fb}
.dmd-fact-value{display:block;margin-top:5px;color:#17324a;font-size:12px;font-weight:800;line-height:1.55;overflow-wrap:anywhere}
.dmd-metrics{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}
.dmd-metric{min-width:0;padding:14px 16px;border:1px solid #e2e8ef;border-radius:13px;background:#fff}
.dmd-metric-label{color:#718497;font-size:11px;font-weight:750}
.dmd-metric-value{display:block;margin-top:5px;color:#17324a;font-size:20px;font-weight:900;line-height:1.2;overflow-wrap:anywhere}
.dmd-detail-panels{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));align-items:start;gap:14px}
.dmd-panel{min-width:0;padding:17px}
.dmd-panel-heading{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0;color:#17324a;font-size:15px;font-weight:900}
.dmd-panel-count{color:#8593a1;font-size:11px;font-weight:750}
.dmd-entry-list{display:grid;gap:8px;margin-top:12px}
.dmd-entry{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;padding:12px;border:1px solid #edf0f3;border-radius:11px;background:#fcfdfe}
.dmd-entry-main{min-width:0;flex:1}
.dmd-entry-title{display:block;color:#17324a;font-size:13px;font-weight:850;line-height:1.45;overflow-wrap:anywhere}
.dmd-entry-meta{display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-top:7px;color:#718497;font-size:10px;line-height:1.5}
.dmd-entry-quantity{flex:0 0 auto;color:#17324a;font-size:12px;font-weight:900;text-align:right;white-space:nowrap}
.dmd-small-status{display:inline-flex;align-items:center;min-height:22px;padding:0 8px;border-radius:999px;background:#edf5fb;color:#2872a8;font-size:10px;font-weight:850}
.dmd-small-status.is-good{background:#eaf7f0;color:#18764b}
.dmd-small-status.is-error{background:#fff1f0;color:#b83e3e}
.dmd-progress-card{padding:16px 18px}
.dmd-progress-list{display:flex;gap:7px;flex-wrap:wrap;margin-top:11px}
.dmd-progress-chip{padding:7px 10px;border-radius:9px;background:#f3f6f8;color:#40566a;font-size:11px;font-weight:800}
.dmd-technical{overflow:hidden;border:1px solid #e2e8ef;border-radius:13px;background:#fff}
.dmd-technical>summary{padding:14px 16px;color:#526578;font-size:12px;font-weight:850;cursor:pointer}
.dmd-technical-body{display:grid;gap:12px;padding:0 15px 15px}
.dmd-technical-path{padding:10px 12px;border-radius:9px;background:#f3f6f9;color:#40566a;font:10px/1.6 ui-monospace,SFMono-Regular,Menlo,monospace;overflow-wrap:anywhere}
.dmd-technical-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:8px}
.dmd-technical-cell{min-width:0;padding:9px 10px;border-radius:9px;background:#f6f9fb}
.dmd-technical-cell small{display:block;color:#718497;font-size:9px;font-weight:800}
.dmd-technical-cell span{display:block;margin-top:4px;color:#40566a;font-size:10px;font-weight:750;overflow-wrap:anywhere}
.dmd-raw-details{overflow:hidden;border:1px solid #e2e8ef;border-radius:10px}
.dmd-raw-details>summary{padding:11px 12px;color:#526578;font-size:11px;font-weight:800;cursor:pointer}
.dmd-raw-details pre{max-height:420px;margin:0;padding:13px;overflow:auto;border-top:1px solid #e2e8ef;background:#111923;color:#d7e3ef;font:10px/1.6 ui-monospace,SFMono-Regular,Menlo,monospace;white-space:pre-wrap;overflow-wrap:anywhere}
@media(max-width:760px){.dmd-detail-panels{grid-template-columns:minmax(0,1fr)}.dmd-overview-card{padding:17px}.dmd-main-title{font-size:20px}}
@media(max-width:520px){.dmd-detail-toolbar{align-items:flex-start;flex-direction:column}.dmd-overview-top{flex-direction:column}.dmd-recipient-line{flex-direction:column}.dmd-company{max-width:none;text-align:left}.dmd-overview-facts{grid-template-columns:minmax(0,1fr)}.dmd-metrics{gap:7px}.dmd-metric{padding:11px}.dmd-metric-value{font-size:17px}}
`;

const styles = {
  page: {
    height: "calc(100vh - 160px)",
    minHeight: 0,
    width: "calc(100% + 44px)",
    margin: "-22px",
    overflowX: "hidden",
    overflowY: "scroll",
    overscrollBehavior: "contain",
    scrollbarGutter: "stable",
    scrollbarWidth: "thin",
    scrollbarColor: "#8F9EAA #E8EDF2",
    WebkitOverflowScrolling: "touch",
    padding: "16px 18px 32px",
    background: "#F5F6F8",
    color: palette.text,
    fontFamily: 'Inter, "Noto Sans TC", sans-serif',
    boxSizing: "border-box",
  },
  content: { width: "min(100%, 1440px)", margin: "0 auto" },
  heading: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    marginBottom: 20,
  },
  title: {
    margin: 0,
    color: palette.text,
    fontSize: 28,
    fontWeight: 850,
    letterSpacing: "-0.03em",
  },
  subtitle: { margin: "7px 0 0", color: palette.soft, fontSize: 13, lineHeight: 1.65 },
  badge: {
    flex: "0 0 auto",
    padding: "7px 11px",
    borderRadius: 999,
    background: palette.greenSoft,
    color: palette.green,
    fontSize: 11,
    fontWeight: 850,
  },
  card: {
    marginTop: 15,
    padding: "19px clamp(15px, 2.5vw, 25px)",
    border: `1px solid ${palette.line}`,
    borderRadius: 17,
    background: palette.white,
    boxShadow: "0 8px 24px rgba(15,35,55,.04)",
  },
  sectionHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    margin: 0,
    color: palette.text,
    fontSize: 16,
    fontWeight: 850,
  },
  orgForm: {
    display: "flex",
    alignItems: "end",
    flexWrap: "wrap",
    gap: 10,
    marginTop: 15,
  },
  field: { display: "grid", flex: "1 1 260px", gap: 6, color: palette.soft, fontSize: 11, fontWeight: 750 },
  input: {
    width: "100%",
    minHeight: 42,
    padding: "0 12px",
    border: `1px solid ${palette.line}`,
    borderRadius: 10,
    outlineColor: palette.blue,
    background: palette.white,
    color: palette.text,
    fontFamily: "inherit",
    fontSize: 13,
    boxSizing: "border-box",
  },
  button: {
    minHeight: 42,
    padding: "0 16px",
    border: 0,
    borderRadius: 10,
    background: palette.orange,
    color: palette.white,
    fontFamily: "inherit",
    fontSize: 12,
    fontWeight: 850,
    cursor: "pointer",
  },
  dangerCard: {
    marginTop: 16,
    padding: 15,
    border: "1px solid #F1D0CD",
    borderRadius: 13,
    background: "#FFF9F8",
  },
  dangerButton: {
    minHeight: 40,
    padding: "0 14px",
    border: 0,
    borderRadius: 9,
    background: palette.red,
    color: palette.white,
    fontFamily: "inherit",
    fontSize: 12,
    fontWeight: 850,
    cursor: "pointer",
  },
  backButton: {
    minHeight: 38,
    marginBottom: 14,
    padding: "0 12px",
    border: `1px solid ${palette.line}`,
    borderRadius: 10,
    background: palette.white,
    color: palette.blue,
    fontFamily: "inherit",
    fontSize: 12,
    fontWeight: 800,
    cursor: "pointer",
  },
  helper: { margin: "10px 0 0", color: palette.soft, fontSize: 11, lineHeight: 1.65, overflowWrap: "anywhere" },
  count: { flex: "0 0 auto", color: palette.soft, fontSize: 11, fontWeight: 750 },
  list: { display: "grid", gap: 10, marginTop: 14 },
  listButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
    padding: "15px 16px",
    border: `1px solid ${palette.line}`,
    borderRadius: 13,
    background: palette.white,
    color: palette.text,
    fontFamily: "inherit",
    textAlign: "left",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  mainText: { minWidth: 0, flex: 1 },
  name: { color: palette.text, fontSize: 15, fontWeight: 850, overflowWrap: "anywhere" },
  email: { marginTop: 4, color: palette.blue, fontSize: 12, fontWeight: 700, overflowWrap: "anywhere" },
  subline: { marginTop: 6, color: palette.soft, fontSize: 11, lineHeight: 1.55, overflowWrap: "anywhere" },
  arrow: { flex: "0 0 auto", color: palette.soft, fontSize: 22, fontWeight: 500 },
  error: {
    marginTop: 14,
    padding: "12px 14px",
    border: "1px solid #F3D1CE",
    borderRadius: 11,
    background: palette.redSoft,
    color: palette.red,
    fontSize: 12,
    fontWeight: 750,
    lineHeight: 1.65,
    overflowWrap: "anywhere",
  },
  loading: { marginTop: 14, padding: 15, borderRadius: 11, background: palette.blueSoft, color: palette.blue, fontSize: 12, fontWeight: 800 },
  empty: { margin: "14px 0 0", padding: 16, borderRadius: 11, background: "#F6F9FB", color: palette.soft, fontSize: 12, lineHeight: 1.65 },
  detailTitle: { margin: "5px 0 0", color: palette.text, fontSize: 21, fontWeight: 850, overflowWrap: "anywhere" },
  rowValue: { flex: "0 0 auto", color: palette.text, fontSize: 12, fontWeight: 800, textAlign: "right", whiteSpace: "nowrap" },
  path: { display: "block", marginTop: 9, padding: "10px 12px", borderRadius: 9, background: "#F3F6F9", color: "#40566A", fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace", fontSize: 10, lineHeight: 1.6, overflowWrap: "anywhere" },
};

function isLocalhost() {
  return typeof window !== "undefined" &&
    ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);
}

function recipientName(profile) {
  return String(profile?.displayName || profile?.name || profile?.contactName || "").trim();
}

function recipientEmail(profile) {
  return String(profile?.emailNormalized || profile?.email || profile?.emailAddress || "").trim();
}

function deliveryName(delivery) {
  return String(delivery?.applicationName || delivery?.applicationTitle || delivery?.title || delivery?.applicationId || delivery?.id || "未命名配送").trim();
}

function getStops(record) {
  if (Array.isArray(record?.stops) && record.stops.length) return record.stops;
  if (Array.isArray(record?.stopRecords)) return record.stopRecords;
  return [];
}

function getCargoItems(record) {
  if (Array.isArray(record?.cargoItems) && record.cargoItems.length) return record.cargoItems;
  if (Array.isArray(record?.items) && record.items.length) return record.items;
  return getStops(record).flatMap((stop) => {
    const items = Array.isArray(stop?.cargoItems)
      ? stop.cargoItems
      : Array.isArray(stop?.items)
        ? stop.items
        : Array.isArray(stop?.contents)
          ? stop.contents
          : [];
    return items.map((item) => ({
      ...item,
      stopId: item?.stopId || stop?.stopId || stop?.id || "",
      stopAddress: item?.stopAddress || stop?.address || stop?.locationText || stop?.name || "",
    }));
  });
}

function operationLabel(value, cargoItems = [], fallback = "收件") {
  const values = [value, ...cargoItems.map((item) => item?.operationType)]
    .map((item) => String(item || "").trim().toUpperCase());
  const hasPickup = values.some((item) => ["PICKUP", "PICKUP_DELIVERY", "寄件", "寄出", "取貨"].includes(item));
  const hasDelivery = values.some((item) => ["DELIVERY", "PICKUP_DELIVERY", "收件", "送貨", "派送"].includes(item));
  if (hasPickup && hasDelivery) return "寄件＋收件";
  if (hasPickup) return "寄件";
  if (hasDelivery) return "收件";
  return fallback;
}

function statusLabel(value) {
  const raw = String(value || "").trim();
  if (!raw) return "狀態未提供";
  const labels = {
    assigned: "已派車",
    pending: "待開始",
    active: "有效",
    busy: "配送中",
    paused: "暫停中",
    completed: "已完成",
    in_progress: "進行中",
    pending_pickup: "待取貨",
    picked_up: "已取貨",
    in_transit: "運送中",
    out_for_delivery: "配送中",
    delivered: "已送達",
    exception: "異常",
    cancelled: "已取消",
  };
  const translated = labels[raw.toLowerCase()];
  return translated && raw.toLowerCase() !== translated.toLowerCase()
    ? `${translated}（${raw}）`
    : translated || raw;
}

function statusTone(value) {
  const status = String(value || "").trim().toUpperCase();
  if (["DELIVERED", "COMPLETED", "PICKED_UP", "已送達", "已完成", "已取貨"].includes(status)) return "is-good";
  if (["EXCEPTION", "CANCELLED", "CANCELED", "異常", "已取消"].includes(status)) return "is-error";
  return "";
}

function getStationProgressStatus(stop) {
  const raw = String(stop?.progress?.status || "").trim().toLowerCase();
  if (stop?.cargoExceptionSummary?.hasException === true || Number(stop?.cargoExceptionSummary?.exceptionCount) > 0) return "exception";
  if (stop?.progress?.completedAt || ["completed", "done"].includes(raw)) return "completed";
  if (stop?.progress?.arrivedAt || raw === "arrived") return "arrived";
  if (raw === "approaching") return "approaching";
  if (["in_progress", "active", "current"].includes(raw)) return "in_progress";
  return "pending";
}

function stationProgressLabel(status) {
  const labels = {
    pending: "待開始",
    approaching: "即將抵達",
    arrived: "已抵達",
    in_progress: "進行中",
    completed: "已完成",
    exception: "異常",
  };
  return labels[status] || "進度未提供";
}

function getCargoExecutionStatus(value) {
  const status = String(typeof value === "object" ? value?.status || "" : value || "").trim().toUpperCase();
  return ["IN_PROGRESS", "COMPLETED", "EXCEPTION"].includes(status) ? status : "";
}

function cargoExecutionLabel(operationType, value) {
  const status = getCargoExecutionStatus(value);
  if (!status) return "";
  if (status === "COMPLETED") return "已完成";
  if (status === "EXCEPTION") return "異常";
  const operation = String(operationType || "").trim().toUpperCase();
  if (operation === "PICKUP") return "前往取貨中";
  if (operation === "DELIVERY") return "配送中";
  return "處理中";
}

function enabledLabel(value) {
  if (value === true) return "已啟用";
  if (value === false) return "停用";
  return "文件未提供";
}

function toMillis(value) {
  if (value && typeof value.toMillis === "function") return value.toMillis();
  if (value && typeof value.toDate === "function") return value.toDate().getTime();
  if (value instanceof Date) return value.getTime();
  const parsed = Date.parse(String(value || ""));
  return Number.isFinite(parsed) ? parsed : 0;
}

function formatDate(value) {
  if (value && typeof value.toDate === "function") {
    return value.toDate().toLocaleString("zh-TW", { hour12: false });
  }
  if (value instanceof Date) return value.toLocaleString("zh-TW", { hour12: false });
  if (typeof value === "number" && Number.isFinite(value)) {
    return new Date(value).toLocaleString("zh-TW", { hour12: false });
  }
  if (value === null || value === undefined || value === "") return "文件未提供";
  return String(value);
}

function formatRawDocument(record) {
  return JSON.stringify(record, (key, value) => {
    if (/token/i.test(key)) return "[已隱藏]";
    if (key === "trackingUrl" && typeof value === "string") {
      return value.replace(/([?&]token=)[^&]+/i, "$1[已隱藏]");
    }
    return value;
  }, 2);
}

function errorText(error, fallback) {
  const code = error?.code ? ` (${error.code})` : "";
  return `${fallback}${code}：${error?.message || "請確認目前登入帳號的 Firestore Rules 權限。"}`;
}

async function collectRecipientCleanupTargets(targetOrgId) {
  const profilesSnapshot = await getDocs(collection(db, "orgs", targetOrgId, "recipientProfiles"));
  const emailIndexSnapshot = await getDocs(collection(db, "orgs", targetOrgId, "recipientEmailIndex"));
  const trackingLinksSnapshot = await getDocs(query(
    collection(db, "publicTrackingLinks"),
    where("orgId", "==", targetOrgId),
  ));
  const profileDocs = profilesSnapshot.docs;
  const deliverySnapshots = await Promise.all(profileDocs.map((profileDoc) => getDocs(collection(
    db,
    "orgs",
    targetOrgId,
    "recipientProfiles",
    profileDoc.id,
    "deliveries",
  ))));
  const deliveryDocs = deliverySnapshots.flatMap((snapshot) => snapshot.docs);
  const linkDocs = trackingLinksSnapshot.docs;
  const authSnapshots = await Promise.all(linkDocs.map((linkDoc) => getDoc(doc(
    db,
    "publicTrackingAuth",
    linkDoc.id,
  ))));
  const authDocs = authSnapshots.filter((snapshot) => snapshot.exists());
  const refs = [
    ...authDocs.map((item) => item.ref),
    ...emailIndexSnapshot.docs.map((item) => item.ref),
    ...deliveryDocs.map((item) => item.ref),
    ...profileDocs.map((item) => item.ref),
    ...linkDocs.map((item) => item.ref),
  ];
  const uniqueRefs = [...new Map(refs.map((ref) => [ref.path, ref])).values()];
  return {
    refs: uniqueRefs,
    counts: {
      profiles: profileDocs.length,
      deliveries: deliveryDocs.length,
      emailIndexes: emailIndexSnapshot.size,
      trackingLinks: linkDocs.length,
      otpRecords: authDocs.length,
      total: uniqueRefs.length,
    },
  };
}

async function deleteRecipientCleanupTargets(refs) {
  const chunkSize = 400;
  for (let offset = 0; offset < refs.length; offset += chunkSize) {
    const batch = writeBatch(db);
    refs.slice(offset, offset + chunkSize).forEach((ref) => batch.delete(ref));
    await batch.commit();
  }
}

export default function DriverManagerDeliveryDetails() {
  const [orgId, setOrgId] = useState(DEFAULT_ORG_ID);
  const [loadedOrgId, setLoadedOrgId] = useState("");
  const [profiles, setProfiles] = useState([]);
  const [profilesLoading, setProfilesLoading] = useState(false);
  const [profilesError, setProfilesError] = useState("");
  const [profileSearch, setProfileSearch] = useState("");
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [deliveries, setDeliveries] = useState([]);
  const [deliveriesLoading, setDeliveriesLoading] = useState(false);
  const [deliveriesError, setDeliveriesError] = useState("");
  const [selectedDeliveryId, setSelectedDeliveryId] = useState("");
  const [deliveryRecord, setDeliveryRecord] = useState(null);
  const [deliveryLoading, setDeliveryLoading] = useState(false);
  const [deliveryError, setDeliveryError] = useState("");
  const [liveJobRecord, setLiveJobRecord] = useState(null);
  const [liveCargoStates, setLiveCargoStates] = useState({});
  const [liveProgressLoading, setLiveProgressLoading] = useState(false);
  const [liveProgressError, setLiveProgressError] = useState("");
  const [clearPreview, setClearPreview] = useState(null);
  const [clearConfirmText, setClearConfirmText] = useState("");
  const [clearBusy, setClearBusy] = useState(false);
  const [clearError, setClearError] = useState("");
  const [clearNotice, setClearNotice] = useState("");
  const [scrollLayout, setScrollLayout] = useState({ height: 0, paddingX: 22, paddingY: 22 });
  const scrollContainerRef = useRef(null);

  useLayoutEffect(() => {
    const container = scrollContainerRef.current;
    if (!container || typeof window === "undefined") return undefined;

    const inner = container.parentElement;
    const viewport = inner?.parentElement;
    const measure = () => {
      let height = Math.max(180, window.innerHeight - 160);
      let paddingX = 0;
      let paddingY = 0;
      if (inner && viewport) {
        const computed = window.getComputedStyle(inner);
        paddingX = Number.parseFloat(computed.paddingLeft) || 0;
        paddingY = Number.parseFloat(computed.paddingTop) || 0;
        height = Math.max(180, viewport.clientHeight || height);
      }
      setScrollLayout((current) => (
        current.height === height && current.paddingX === paddingX && current.paddingY === paddingY
          ? current
          : { height, paddingX, paddingY }
      ));
    };

    measure();
    const observer = typeof ResizeObserver === "function" ? new ResizeObserver(measure) : null;
    if (observer && viewport) observer.observe(viewport);
    if (observer && inner) observer.observe(inner);
    window.addEventListener("resize", measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  const scanRecipientCleanup = async () => {
    if (!isLocalhost() || !loadedOrgId || loadedOrgId !== orgId.trim()) return;
    setClearBusy(true);
    setClearError("");
    setClearNotice("");
    try {
      const result = await collectRecipientCleanupTargets(loadedOrgId);
      setClearPreview(result.counts);
      setClearConfirmText("");
      setClearNotice(`掃描完成：共 ${result.counts.total} 筆可清除文件。`);
    } catch (error) {
      console.error("[DriverManagerDeliveryDetails] recipient cleanup scan error:", error);
      setClearError(errorText(error, "掃描收件人配送資料失敗；尚未刪除任何文件"));
    } finally {
      setClearBusy(false);
    }
  };

  const clearRecipientData = async () => {
    if (!isLocalhost() || !loadedOrgId || loadedOrgId !== orgId.trim()) return;
    const requiredPhrase = `清除 ${loadedOrgId}`;
    if (clearConfirmText.trim() !== requiredPhrase) {
      setClearError(`請完整輸入「${requiredPhrase}」才可繼續。`);
      return;
    }
    if (!clearPreview) {
      setClearError("請先掃描資料，確認清除範圍與筆數。" );
      return;
    }

    setClearBusy(true);
    setClearError("");
    setClearNotice("");
    try {
      const fresh = await collectRecipientCleanupTargets(loadedOrgId);
      const previewSignature = JSON.stringify(clearPreview);
      const freshSignature = JSON.stringify(fresh.counts);
      if (previewSignature !== freshSignature) {
        setClearPreview(fresh.counts);
        setClearConfirmText("");
        setClearError("掃描後資料數量已變動；為避免刪錯，請重新檢查數量並重新輸入確認文字。尚未刪除任何文件。" );
        return;
      }
      if (!fresh.refs.length) {
        setClearNotice("目前沒有可清除的收件人配送資料。" );
        return;
      }
      const confirmed = window.confirm(
        `即將永久清除組織 ${loadedOrgId} 的 ${fresh.counts.total} 筆文件。\n\n` +
        `包含：收件人 ${fresh.counts.profiles}、配送 ${fresh.counts.deliveries}、Email 索引 ${fresh.counts.emailIndexes}、追蹤連結 ${fresh.counts.trackingLinks}、對應驗證紀錄 ${fresh.counts.otpRecords}。\n\n` +
        "不會刪除 applications/jobs、成員、貨物原始資料或 mail 郵件佇列。此操作無法復原。確定繼續嗎？",
      );
      if (!confirmed) return;

      await deleteRecipientCleanupTargets(fresh.refs);
      setClearPreview(null);
      setClearConfirmText("");
      await loadProfiles(loadedOrgId);
      setClearNotice(`已清除組織 ${loadedOrgId} 的 ${fresh.counts.total} 筆 recipient / tracking 文件。`);
    } catch (error) {
      console.error("[DriverManagerDeliveryDetails] recipient cleanup error:", error);
      setClearError(errorText(error, "清除未完整完成；可重新掃描後安全重試"));
    } finally {
      setClearBusy(false);
    }
  };

  const loadProfiles = useCallback(async (targetOrgId) => {
    const nextOrgId = String(targetOrgId || "").trim();
    if (!nextOrgId) {
      setProfilesError("請輸入 Organization ID。");
      setProfiles([]);
      setLoadedOrgId("");
      return;
    }

    setOrgId(nextOrgId);
    setProfilesLoading(true);
    setProfilesError("");
    setProfiles([]);
    setLoadedOrgId("");
    setClearPreview(null);
    setClearConfirmText("");
    setClearError("");
    setClearNotice("");
    setSelectedProfile(null);
    setSelectedDeliveryId("");
    setDeliveryRecord(null);
    try {
      const snapshot = await getDocs(collection(db, "orgs", nextOrgId, "recipientProfiles"));
      const rows = snapshot.docs.map((item) => ({ ...item.data(), id: item.id }));
      rows.sort((a, b) => {
        const nameCompare = recipientName(a).localeCompare(recipientName(b), "zh-TW");
        return nameCompare || recipientEmail(a).localeCompare(recipientEmail(b));
      });
      setProfiles(rows);
      setLoadedOrgId(nextOrgId);
    } catch (error) {
      console.error("[DriverManagerDeliveryDetails] recipientProfiles read error:", error);
      setProfilesError(errorText(error, "讀取收件人清單失敗"));
    } finally {
      setProfilesLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isLocalhost()) void loadProfiles(DEFAULT_ORG_ID);
  }, [loadProfiles]);

  useEffect(() => {
    if (!selectedProfile?.id || !loadedOrgId) return undefined;
    let active = true;
    const loadDeliveries = async () => {
      setDeliveriesLoading(true);
      setDeliveriesError("");
      setDeliveries([]);
      try {
        const snapshot = await getDocs(collection(
          db,
          "orgs",
          loadedOrgId,
          "recipientProfiles",
          selectedProfile.id,
          "deliveries",
        ));
        if (!active) return;
        const rows = snapshot.docs.map((item) => ({ ...item.data(), id: item.id }));
        rows.sort((a, b) => {
          const dateCompare = String(b.dateKey || b.workDateKey || "").localeCompare(String(a.dateKey || a.workDateKey || ""));
          return dateCompare || toMillis(b.startAt || b.updatedAt || b.createdAt) - toMillis(a.startAt || a.updatedAt || a.createdAt);
        });
        setDeliveries(rows);
      } catch (error) {
        if (!active) return;
        console.error("[DriverManagerDeliveryDetails] deliveries read error:", error);
        setDeliveriesError(errorText(error, "讀取配送清單失敗"));
      } finally {
        if (active) setDeliveriesLoading(false);
      }
    };
    void loadDeliveries();
    return () => { active = false; };
  }, [loadedOrgId, selectedProfile?.id]);

  const openDelivery = async (deliveryId) => {
    if (!loadedOrgId || !selectedProfile?.id || !deliveryId) return;
    setSelectedDeliveryId(deliveryId);
    setDeliveryRecord(null);
    setDeliveryError("");
    setDeliveryLoading(true);
    try {
      const snapshot = await getDoc(doc(
        db,
        "orgs",
        loadedOrgId,
        "recipientProfiles",
        selectedProfile.id,
        "deliveries",
        deliveryId,
      ));
      if (!snapshot.exists()) {
        setDeliveryError("找不到這筆配送文件，可能已被移除。");
        return;
      }
      setDeliveryRecord({ ...snapshot.data(), id: snapshot.id });
    } catch (error) {
      console.error("[DriverManagerDeliveryDetails] delivery document read error:", error);
      setDeliveryError(errorText(error, "讀取單筆配送文件失敗"));
    } finally {
      setDeliveryLoading(false);
    }
  };

  const goToRecipientList = () => {
    setSelectedProfile(null);
    setSelectedDeliveryId("");
    setDeliveryRecord(null);
    setDeliveries([]);
    setDeliveriesError("");
  };

  const goToDeliveryList = () => {
    setSelectedDeliveryId("");
    setDeliveryRecord(null);
    setDeliveryError("");
  };

  const visibleProfiles = profiles.filter((profile) => {
    const needle = profileSearch.trim().toLocaleLowerCase();
    if (!needle) return true;
    return `${recipientName(profile)} ${recipientEmail(profile)} ${profile.company || ""}`
      .toLocaleLowerCase()
      .includes(needle);
  });
  const currentDelivery = deliveries.find((item) => item.id === selectedDeliveryId);
  const detailRecord = deliveryRecord || currentDelivery || {};
  const detailApplicationId = String(detailRecord.applicationId || selectedDeliveryId || "").trim();
  const detailWorkDateKey = String(detailRecord.workDateKey || detailRecord.dateKey || "").trim();

  useEffect(() => {
    if (!loadedOrgId || !selectedProfile?.id || !selectedDeliveryId) {
      setLiveJobRecord(null);
      setLiveCargoStates({});
      setLiveProgressLoading(false);
      setLiveProgressError("");
      return undefined;
    }
    if (!detailApplicationId || !detailWorkDateKey) {
      setLiveJobRecord(null);
      setLiveCargoStates({});
      setLiveProgressLoading(false);
      setLiveProgressError("配送文件缺少日期或 Application ID，無法讀取成員端即時進度。");
      return undefined;
    }

    let active = true;
    let jobReady = false;
    let cargoStatesReady = false;
    let jobError = "";
    let cargoStatesError = "";
    const updateError = () => {
      if (active) setLiveProgressError(jobError || cargoStatesError);
    };
    const finishLoading = () => {
      if (active && jobReady && cargoStatesReady) setLiveProgressLoading(false);
    };

    setLiveJobRecord(null);
    setLiveCargoStates({});
    setLiveProgressLoading(true);
    setLiveProgressError("");

    const jobRef = doc(db, "orgs", loadedOrgId, "applications", detailWorkDateKey, "jobs", detailApplicationId);
    const unsubscribeJob = onSnapshot(jobRef, (snapshot) => {
      if (!active) return;
      jobReady = true;
      if (snapshot.exists()) {
        setLiveJobRecord({ ...snapshot.data(), id: snapshot.id });
        jobError = "";
      } else {
        setLiveJobRecord(null);
        jobError = "找不到對應的工作文件；目前配送資料仍顯示建立時保存的狀態快照。";
      }
      updateError();
      finishLoading();
    }, (error) => {
      if (!active) return;
      jobReady = true;
      jobError = errorText(error, "讀取成員端工作進度失敗");
      console.error("[DriverManagerDeliveryDetails] live application listener error:", error);
      updateError();
      finishLoading();
    });

    const unsubscribeCargoStates = onSnapshot(collection(jobRef, "cargoStates"), (snapshot) => {
      if (!active) return;
      cargoStatesReady = true;
      const states = {};
      snapshot.docs.forEach((item) => { states[item.id] = item.data() || {}; });
      setLiveCargoStates(states);
      cargoStatesError = "";
      updateError();
      finishLoading();
    }, (error) => {
      if (!active) return;
      cargoStatesReady = true;
      cargoStatesError = errorText(error, "讀取貨物即時執行狀態失敗");
      console.error("[DriverManagerDeliveryDetails] cargo states listener error:", error);
      updateError();
      finishLoading();
    });

    return () => {
      active = false;
      unsubscribeJob();
      unsubscribeCargoStates();
    };
  }, [detailApplicationId, detailWorkDateKey, loadedOrgId, selectedDeliveryId, selectedProfile?.id]);

  const detailStops = getStops(detailRecord);
  const detailCargoItems = getCargoItems(detailRecord);
  const liveJobStops = getStops(liveJobRecord);
  const detailOperation = operationLabel(detailRecord.operationType, detailCargoItems, "收件");
  const detailStatusValue = detailRecord.status || detailRecord.progress?.status || detailCargoItems[0]?.status;
  const detailStatus = statusLabel(detailStatusValue);
  const detailItemCount = detailRecord.cargoCount ?? detailCargoItems.length;
  const detailTotalQuantity = detailRecord.cargoQuantity ?? detailCargoItems.reduce((sum, item) => {
    const quantity = Number(item?.quantity ?? item?.totalQuantity ?? item?.qty ?? 0);
    return sum + (Number.isFinite(quantity) ? quantity : 0);
  }, 0);
  const detailQuantityUnits = [...new Set(detailCargoItems.map((item) => String(item?.unit || "件").trim()).filter(Boolean))];
  const detailQuantityUnit = detailQuantityUnits.length === 1 ? detailQuantityUnits[0] : "";
  const recipientExecutionProjection = detailRecord.executionProjection && typeof detailRecord.executionProjection === "object"
    ? detailRecord.executionProjection
    : {};
  const recipientProjectionStops = Array.isArray(recipientExecutionProjection.stops)
    ? recipientExecutionProjection.stops
    : [];
  const recipientProjectionCargoItems = (Array.isArray(recipientExecutionProjection.cargoItems)
    ? recipientExecutionProjection.cargoItems
    : []).filter((item) =>
      getCargoExecutionStatus(item) || item?.startedAt || item?.completedAt || item?.lastExceptionAt || item?.updatedAt,
    );
  const recipientProjectionWorkTimes = [
    ["工作開始", recipientExecutionProjection.startedAt],
    ["暫停", recipientExecutionProjection.pausedAt],
    ["恢復", recipientExecutionProjection.resumedAt],
    ["工作完成", recipientExecutionProjection.completedAt],
  ].filter(([, value]) => value);
  const detailLiveExecutionCounts = detailCargoItems.reduce((counts, item) => {
    const contentId = String(item?.id || item?.contentId || "").trim();
    const executionStatus = getCargoExecutionStatus(liveCargoStates[contentId]);
    const label = cargoExecutionLabel(item?.operationType || detailRecord.operationType, executionStatus);
    if (label) counts[label] = (counts[label] || 0) + 1;
    return counts;
  }, {});
  const detailLiveExecutionEntries = Object.entries(detailLiveExecutionCounts);
  const findLiveStop = (deliveryStop, index) => {
    const stopId = String(deliveryStop?.stopId || deliveryStop?.id || "").trim().toUpperCase();
    if (stopId) {
      return liveJobStops.find((stop) => String(stop?.id || stop?.stopId || "").trim().toUpperCase() === stopId) || null;
    }
    const order = Number(deliveryStop?.order ?? index + 1);
    return liveJobStops.find((stop, stopIndex) => Number(stop?.order ?? stop?.sequence ?? stopIndex + 1) === order) || null;
  };
  const fullPath = loadedOrgId && selectedProfile?.id && selectedDeliveryId
    ? `orgs/${loadedOrgId}/recipientProfiles/${selectedProfile.id}/deliveries/${selectedDeliveryId}`
    : "";
  const pageScrollStyle = {
    ...styles.page,
    ...(scrollLayout.height
      ? {
          height: `${scrollLayout.height}px`,
          width: `calc(100% + ${scrollLayout.paddingX * 2}px)`,
          margin: `-${scrollLayout.paddingY}px -${scrollLayout.paddingX}px`,
        }
      : {}),
  };

  if (!isLocalhost()) {
    return (
      <main style={styles.page}>
        <div style={styles.content}>
          <div style={styles.error}>此配送詳情檢視器僅允許從 localhost 開啟。</div>
        </div>
      </main>
    );
  }

  const profileLevel = !selectedProfile;
  const deliveryListLevel = Boolean(selectedProfile) && !selectedDeliveryId;
  const detailLevel = Boolean(selectedProfile && selectedDeliveryId);

  return (
    <main ref={scrollContainerRef} className="dmd-page-scroll" style={pageScrollStyle}>
      <style>{`${DELIVERY_SCROLLBAR_CSS}\n${DELIVERY_DETAILS_CSS}`}</style>
      <div style={styles.content}>
        <header style={styles.heading}>
          <div>
            <h1 style={styles.title}>配送詳情</h1>
            <p style={styles.subtitle}>一般資料檢視為唯讀；僅收件人清除工具會在預覽、輸入組織 ID 及二次確認後刪除限定資料。</p>
          </div>
          <span style={styles.badge}>localhost only</span>
        </header>

        {profileLevel ? (
          <section style={styles.card}>
            <h2 style={styles.sectionHeading}>
              收件人清單
              <span style={styles.count}>{profiles.length} 位</span>
            </h2>
            <form
              style={styles.orgForm}
              onSubmit={(event) => { event.preventDefault(); void loadProfiles(orgId); }}
            >
              <label style={styles.field}>
                Organization ID
                <input style={styles.input} value={orgId} onChange={(event) => { setOrgId(event.target.value); setClearPreview(null); setClearConfirmText(""); setClearError(""); setClearNotice(""); }} required />
              </label>
              <button type="submit" style={styles.button} disabled={profilesLoading}>
                {profilesLoading ? "讀取中…" : "重新讀取收件人"}
              </button>
            </form>
            <div style={styles.dangerCard}>
              <div style={{ ...styles.sectionHeading, color: palette.red, fontSize: 14 }}>清除目前組織的收件人配送資料</div>
              <p style={{ ...styles.helper, marginTop: 7 }}>
                僅限已成功載入且目前輸入欄位仍相符的 Organization ID。將清除 recipientProfiles（含 deliveries）、recipientEmailIndex、該組織的 publicTrackingLinks，以及同 token 雜湊的 OTP/session 文件；不刪除 applications/jobs、成員、貨物原始資料或 mail 郵件佇列。此 localhost 按鈕依賴目前 Firestore Rules，並非後端管理權限邊界。
              </p>
              <div style={{ ...styles.orgForm, marginTop: 11 }}>
                <button
                  type="button"
                  style={styles.backButton}
                  disabled={clearBusy || !loadedOrgId || loadedOrgId !== orgId.trim()}
                  onClick={() => void scanRecipientCleanup()}
                >
                  {clearBusy ? "處理中…" : "掃描可清除資料"}
                </button>
                {clearPreview ? <span style={styles.count}>收件人 {clearPreview.profiles} · 配送 {clearPreview.deliveries} · Email 索引 {clearPreview.emailIndexes} · 追蹤連結 {clearPreview.trackingLinks} · 驗證紀錄 {clearPreview.otpRecords} · 合計 {clearPreview.total} 筆</span> : null}
              </div>
              {clearPreview?.total > 0 ? (
                <div style={{ ...styles.orgForm, alignItems: "end", marginTop: 10 }}>
                  <label style={styles.field}>
                    輸入確認文字：<strong style={{ color: palette.red }}>清除 {loadedOrgId}</strong>
                    <input
                      style={styles.input}
                      value={clearConfirmText}
                      onChange={(event) => { setClearConfirmText(event.target.value); setClearError(""); }}
                      placeholder={`清除 ${loadedOrgId}`}
                      autoComplete="off"
                      spellCheck={false}
                    />
                  </label>
                  <button
                    type="button"
                    style={{ ...styles.dangerButton, opacity: clearBusy || clearConfirmText.trim() !== `清除 ${loadedOrgId}` ? 0.55 : 1 }}
                    disabled={clearBusy || clearConfirmText.trim() !== `清除 ${loadedOrgId}`}
                    onClick={() => void clearRecipientData()}
                  >
                    {clearBusy ? "清除中…" : "永久清除資料"}
                  </button>
                </div>
              ) : null}
              {clearNotice ? <div style={{ ...styles.loading, marginTop: 10 }}>{clearNotice}</div> : null}
              {clearError ? <div role="alert" style={styles.error}>{clearError}</div> : null}
            </div>
            <p style={styles.helper}>先依姓名與 Email 選擇收件人，再進入該收件人的配送資料。資料來源：orgs/{loadedOrgId || orgId}/recipientProfiles</p>
            <label style={{ ...styles.field, marginTop: 14 }}>
              搜尋姓名、Email 或公司
              <input style={styles.input} value={profileSearch} onChange={(event) => setProfileSearch(event.target.value)} placeholder="輸入姓名或 Email" />
            </label>
            {profilesLoading ? <div style={styles.loading}>正在讀取收件人資料…</div> : null}
            {profilesError ? <div role="alert" style={styles.error}>{profilesError}</div> : null}
            {!profilesLoading && !profilesError && !visibleProfiles.length ? (
              <p style={styles.empty}>{profiles.length ? "沒有符合搜尋條件的收件人。" : "目前沒有收件人資料。"}</p>
            ) : null}
            <div style={styles.list}>
              {visibleProfiles.map((profile) => (
                <button
                  type="button"
                  key={profile.id}
                  style={styles.listButton}
                  onClick={() => {
                    setSelectedProfile(profile);
                    setSelectedDeliveryId("");
                    setDeliveryRecord(null);
                  }}
                >
                  <span style={styles.mainText}>
                    <span style={styles.name}>{recipientName(profile) || "姓名未提供"}</span>
                    <span style={styles.email}>{recipientEmail(profile) || "Email 未提供"}</span>
                    {profile.company ? <span style={styles.subline}>{profile.company}</span> : null}
                  </span>
                  <span style={styles.arrow} aria-hidden="true">›</span>
                </button>
              ))}
            </div>
          </section>
        ) : null}

        {selectedProfile ? (
          <section style={styles.card}>
            <button type="button" style={styles.backButton} onClick={goToRecipientList}>‹ 所有收件人</button>
            <div style={styles.sectionHeading}>收件人資料</div>
            <h2 style={styles.detailTitle}>{recipientName(selectedProfile) || "姓名未提供"}</h2>
            <div style={styles.email}>{recipientEmail(selectedProfile) || "Email 未提供"}</div>
            {selectedProfile.company ? <div style={styles.subline}>{selectedProfile.company}</div> : null}
            <div style={styles.path}>orgs/{loadedOrgId}/recipientProfiles/{selectedProfile.id}</div>
          </section>
        ) : null}

        {deliveryListLevel ? (
          <section style={styles.card}>
            <h2 style={styles.sectionHeading}>
              配送清單
              <span style={styles.count}>{deliveries.length} 筆</span>
            </h2>
            {deliveriesLoading ? <div style={styles.loading}>正在讀取此收件人的配送資料…</div> : null}
            {deliveriesError ? <div role="alert" style={styles.error}>{deliveriesError}</div> : null}
            {!deliveriesLoading && !deliveriesError && !deliveries.length ? (
              <p style={styles.empty}>此收件人目前沒有 deliveries 文件。</p>
            ) : null}
            <div style={styles.list}>
              {deliveries.map((delivery) => {
                const items = getCargoItems(delivery);
                const operation = operationLabel(delivery.operationType, items, "收件");
                const status = statusLabel(delivery.status || delivery.progress?.status || delivery.access?.status || items[0]?.status);
                const itemCount = delivery.cargoCount ?? items.length;
                const cargoSummary = items.length
                  ? items.slice(0, 2).map((item) => {
                      const name = item.name || item.itemName || item.cargoName || "未命名貨物";
                      const quantityValue = item.quantity ?? item.totalQuantity ?? item.qty;
                      return quantityValue === null || quantityValue === undefined
                        ? name
                        : `${name} ${quantityValue}${item.unit || "件"}`;
                    }).join("、")
                  : delivery.cargoCount
                    ? `${delivery.cargoCount} 項貨物（此配送摘要沒有 cargoItems 明細）`
                    : "此配送文件沒有保存貨物明細";
                const address = getStops(delivery).map((stop) => stop?.address || stop?.locationText || stop?.name).filter(Boolean).slice(0, 2).join("、");
                return (
                  <button type="button" key={delivery.id} style={styles.listButton} onClick={() => void openDelivery(delivery.id)}>
                    <span style={styles.mainText}>
                      <span style={styles.name}>{deliveryName(delivery)}</span>
                      <span style={styles.email}>{delivery.dateKey || delivery.workDateKey || "日期未提供"} · {operation} · {status}</span>
                      <span style={styles.subline}>
                        {cargoSummary}
                        {items.length > 2 ? ` 等 ${items.length} 項` : ""}
                        {address ? ` · ${address}` : ""}
                      </span>
                      <span style={styles.subline}>Delivery ID：{delivery.id} · Application ID：{delivery.applicationId || "文件未提供"}</span>
                    </span>
                    <span style={styles.rowValue}>{itemCount} 項</span>
                    <span style={styles.arrow} aria-hidden="true">›</span>
                  </button>
                );
              })}
            </div>
          </section>
        ) : null}

        {detailLevel ? (
          <div className="dmd-detail-stack">
            <div className="dmd-detail-toolbar">
              <button
                type="button"
                className="dmd-back-button"
                style={{ ...styles.backButton, marginBottom: 0 }}
                onClick={goToDeliveryList}
              >
                ‹ 返回配送清單
              </button>
              <span className="dmd-record-hint">Firestore 配送文件</span>
            </div>

            <section className="dmd-overview-card">
              <div className="dmd-overview-top">
                <div>
                  <div className="dmd-chip-row">
                    <span className="dmd-chip">{detailOperation}</span>
                    <span className="dmd-eyebrow">配送摘要狀態</span>
                  </div>
                  <h2 className="dmd-main-title">{deliveryName(detailRecord)}</h2>
                </div>
                <span className={`dmd-chip dmd-chip-status ${statusTone(detailStatusValue)}`}>
                  {detailStatus}
                </span>
              </div>

              <div className="dmd-recipient-line">
                <div className="dmd-recipient-main">
                  <span className="dmd-meta-label">收件人</span>
                  <strong className="dmd-recipient-name">{recipientName(selectedProfile) || "姓名未提供"}</strong>
                  <span className="dmd-recipient-email">{detailRecord.email || recipientEmail(selectedProfile) || "Email 未提供"}</span>
                </div>
                {selectedProfile?.company ? <span className="dmd-company">{selectedProfile.company}</span> : null}
              </div>

              <div className="dmd-overview-facts">
                <div className="dmd-fact">
                  <span className="dmd-meta-label">配送日期</span>
                  <span className="dmd-fact-value">{detailRecord.dateKey || detailRecord.workDateKey || "日期未提供"}</span>
                </div>
                <div className="dmd-fact">
                  <span className="dmd-meta-label">預計配送時間</span>
                  <span className="dmd-fact-value">
                    {formatDate(detailRecord.startAt || detailRecord.createdAt)}
                    {detailRecord.scheduledEndAt ? ` — ${formatDate(detailRecord.scheduledEndAt)}` : ""}
                  </span>
                </div>
              </div>
              {deliveryLoading ? <div style={styles.loading}>正在讀取這一筆配送文件…</div> : null}
              {deliveryError ? <div role="alert" style={styles.error}>{deliveryError}</div> : null}
              {liveProgressLoading ? <div style={styles.loading}>正在同步成員端站點與貨物執行狀態…</div> : null}
              {liveProgressError ? <div role="alert" style={styles.error}>{liveProgressError}</div> : null}
            </section>

            <div className="dmd-metrics">
              <div className="dmd-metric">
                <span className="dmd-metric-label">配送地點</span>
                <strong className="dmd-metric-value">{detailRecord.stopCount ?? detailStops.length} 站</strong>
              </div>
              <div className="dmd-metric">
                <span className="dmd-metric-label">貨物項目</span>
                <strong className="dmd-metric-value">{detailItemCount} 項</strong>
              </div>
              <div className="dmd-metric">
                <span className="dmd-metric-label">數量合計</span>
                <strong className="dmd-metric-value">{detailTotalQuantity}{detailQuantityUnit ? ` ${detailQuantityUnit}` : ""}</strong>
              </div>
            </div>

            <div className="dmd-detail-panels">
              <section className="dmd-panel">
                <h3 className="dmd-panel-heading">
                  配送地點
                  <span className="dmd-panel-count">{detailStops.length} 站</span>
                </h3>
                {detailStops.length ? (
                  <div className="dmd-entry-list">
                    {detailStops.map((stop, index) => {
                      const stopId = stop?.stopId || stop?.id || "";
                      const liveStop = findLiveStop(stop, index);
                      const stationStatus = liveStop ? getStationProgressStatus(liveStop) : "";
                      const stopItems = detailCargoItems.filter((item) => String(item?.stopId || "") === String(stopId));
                      const stopCount = stop?.cargoCount ?? stopItems.length;
                      const stopQuantity = stop?.cargoQuantity;
                      return (
                        <article key={String(stopId || index)} className="dmd-entry">
                          <div className="dmd-entry-main">
                            <strong className="dmd-entry-title">{stop?.address || stop?.locationText || stop?.name || `第 ${index + 1} 個地點`}</strong>
                            <div className="dmd-entry-meta">
                              <span>第 {stop?.order ?? index + 1} 站</span>
                              {stopId ? <span>· ID {stopId}</span> : null}
                              <span className={`dmd-small-status ${statusTone(stationStatus)}`}>
                                {liveStop ? stationProgressLabel(stationStatus) : liveProgressLoading ? "同步中…" : liveProgressError ? "無法讀取" : "未對應工作站點"}
                              </span>
                            </div>
                          </div>
                          <span className="dmd-entry-quantity">
                            {stopQuantity !== undefined && stopQuantity !== null ? `${stopQuantity} 件` : `${stopCount} 項`}
                          </span>
                        </article>
                      );
                    })}
                  </div>
                ) : <p style={styles.empty}>這筆配送文件沒有配送地點資料。</p>}
              </section>

              <section className="dmd-panel">
                <h3 className="dmd-panel-heading">
                  貨物明細
                  <span className="dmd-panel-count">{detailCargoItems.length} 項</span>
                </h3>
                {detailCargoItems.length ? (
                  <div className="dmd-entry-list">
                    {detailCargoItems.map((item, index) => {
                      const itemStop = detailStops.find((stop) => String(stop?.stopId || stop?.id || "") === String(item?.stopId || ""));
                      const contentId = String(item?.id || item?.contentId || "").trim();
                      const executionState = liveCargoStates[contentId];
                      const executionStatus = getCargoExecutionStatus(executionState);
                      const executionLabel = cargoExecutionLabel(item?.operationType || detailRecord.operationType, executionStatus);
                      const itemOperation = operationLabel(item?.operationType, [item], detailOperation);
                      return (
                        <article key={String(item?.id || item?.contentId || index)} className="dmd-entry">
                          <div className="dmd-entry-main">
                            <strong className="dmd-entry-title">{item?.name || item?.itemName || item?.cargoName || "未命名貨物"}</strong>
                            <div className="dmd-entry-meta">
                              <span>{itemOperation}</span>
                              {item?.stopAddress || itemStop?.address ? <span>· {item?.stopAddress || itemStop.address}</span> : null}
                              {item?.status ? <span>· 配送狀態：{statusLabel(item.status)}</span> : null}
                              <span className={`dmd-small-status ${statusTone(executionStatus)}`}>
                                {executionLabel || (liveProgressLoading ? "同步中…" : liveProgressError ? "無法讀取" : "尚無執行記錄")}
                              </span>
                            </div>
                          </div>
                          <span className="dmd-entry-quantity">
                            {item?.quantity ?? item?.totalQuantity ?? item?.qty ?? "—"} {item?.unit || "件"}
                          </span>
                        </article>
                      );
                    })}
                  </div>
                ) : <p style={styles.empty}>這筆配送文件沒有 cargoItems 明細。</p>}
              </section>
            </div>

            <section className="dmd-progress-card">
              <h3 className="dmd-panel-heading">
                收件人同步執行投影
                <span className={`dmd-small-status${recipientExecutionProjection.version ? " is-good" : ""}`}>
                  {recipientExecutionProjection.version ? `v${recipientExecutionProjection.version}` : "尚未同步"}
                </span>
              </h3>
              {recipientExecutionProjection.jobStatus || recipientProjectionWorkTimes.length ? (
                <div className="dmd-entry-meta" style={{ marginTop: 10 }}>
                  {recipientExecutionProjection.jobStatus ? <span>工作狀態：{statusLabel(recipientExecutionProjection.jobStatus)}</span> : null}
                  {recipientProjectionWorkTimes.map(([label, value]) => <span key={label}>{label}：{formatDate(value)}</span>)}
                </div>
              ) : null}
              {recipientProjectionStops.length || recipientProjectionCargoItems.length ? (
                <div className="dmd-entry-list">
                  {recipientProjectionStops.map((stop, index) => {
                    const times = [
                      ["接近", stop.approachingAt],
                      ["抵達", stop.arrivedAt],
                      ["開始", stop.startedAt],
                      ["完成", stop.completedAt],
                    ].filter(([, value]) => value);
                    return (
                      <article key={`projection-stop-${stop.stopId || index}`} className="dmd-entry">
                        <div className="dmd-entry-main">
                          <strong className="dmd-entry-title">站點 {stop.order || index + 1} · {stop.stopId || "未提供 ID"}</strong>
                          <div className="dmd-entry-meta">
                            <span className={`dmd-small-status ${statusTone(stop.status)}`}>{stationProgressLabel(String(stop.status || "").toLowerCase())}</span>
                            {times.map(([label, value]) => <span key={label}>{label}：{formatDate(value)}</span>)}
                          </div>
                        </div>
                      </article>
                    );
                  })}
                  {recipientProjectionCargoItems.map((item, index) => {
                    const staticItem = detailCargoItems.find((candidate) =>
                      String(candidate?.id || candidate?.contentId || "") === String(item.id || "") &&
                      String(candidate?.stopId || "").toUpperCase() === String(item.stopId || "").toUpperCase(),
                    ) || detailCargoItems.find((candidate) =>
                      String(candidate?.id || candidate?.contentId || "") === String(item.id || ""),
                    );
                    const executionLabel = cargoExecutionLabel(
                      item.operationType || staticItem?.operationType || detailRecord.operationType,
                      item.status,
                    ) || statusLabel(item.status);
                    const times = [
                      ["開始", item.startedAt],
                      ["完成", item.completedAt],
                      ["異常", item.lastExceptionAt],
                    ].filter(([, value]) => value);
                    if (!times.length && item.updatedAt) times.push(["更新", item.updatedAt]);
                    return (
                      <article key={`projection-cargo-${item.stopId || ""}-${item.recipientId || ""}-${item.id || index}-${item.operationType || ""}`} className="dmd-entry">
                        <div className="dmd-entry-main">
                          <strong className="dmd-entry-title">{staticItem?.name || staticItem?.itemName || staticItem?.cargoName || item.id || "貨物"}</strong>
                          <div className="dmd-entry-meta">
                            <span>{item.operationType || staticItem?.operationType || detailOperation}</span>
                            {item.stopId ? <span>· 站點 {item.stopId}</span> : null}
                            <span className={`dmd-small-status ${statusTone(item.status)}`}>{executionLabel}</span>
                            {times.map(([label, value]) => <span key={label}>{label}：{formatDate(value)}</span>)}
                          </div>
                        </div>
                      </article>
                    );
                  })}
                </div>
              ) : (
                <p style={styles.empty}>
                  {recipientExecutionProjection.version
                    ? "收件人文件已同步；目前尚無站點或貨物執行時間。"
                    : "尚未收到成員端執行同步；此區只讀取 recipientProfiles 配送文件。"}
                </p>
              )}
            </section>

            <section className="dmd-progress-card">
              <h3 className="dmd-panel-heading">
                成員端即時執行狀態
                <span className="dmd-small-status">即時</span>
              </h3>
              {detailLiveExecutionEntries.length ? (
                <div className="dmd-progress-list">
                  {detailLiveExecutionEntries.map(([label, count]) => (
                    <span key={label} className="dmd-progress-chip">{label} × {count}</span>
                  ))}
                </div>
              ) : <p style={styles.empty}>{liveProgressLoading ? "正在讀取 cargoStates…" : liveProgressError ? "目前無法載入即時狀態；配送摘要快照仍保留於上方。" : "目前尚無成員端 cargoStates 執行紀錄。"}</p>}
            </section>

            <details className="dmd-technical">
              <summary>技術資料與追蹤設定</summary>
              <div className="dmd-technical-body">
                <code className="dmd-technical-path">{fullPath}</code>
                <div className="dmd-technical-grid">
                  <div className="dmd-technical-cell"><small>Application ID</small><span>{detailRecord.applicationId || "文件未提供"}</span></div>
                  <div className="dmd-technical-cell"><small>Recipient Profile ID</small><span>{detailRecord.recipientProfileId || selectedProfile?.id || "文件未提供"}</span></div>
                  <div className="dmd-technical-cell"><small>追蹤連結狀態</small><span>{statusLabel(detailRecord.access?.status)}</span></div>
                  <div className="dmd-technical-cell"><small>Email 通知</small><span>{enabledLabel(detailRecord.access?.emailEnabled)}</span></div>
                  <div className="dmd-technical-cell"><small>LINE 通知</small><span>{enabledLabel(detailRecord.access?.lineEnabled)}</span></div>
                  <div className="dmd-technical-cell"><small>到期時間</small><span>{formatDate(detailRecord.access?.expiresAt)}</span></div>
                  <div className="dmd-technical-cell"><small>到期規則</small><span>{detailRecord.access?.expiresAfter || "文件未提供"}</span></div>
                  <div className="dmd-technical-cell"><small>Scope Key</small><span>{detailRecord.access?.scopeKey || "文件未提供"}</span></div>
                  <div className="dmd-technical-cell"><small>追蹤網址</small><span>{detailRecord.access?.trackingUrl ? "已建立（Token 已隱藏）" : "未建立"}</span></div>
                </div>
                <details className="dmd-raw-details">
                  <summary>Firestore 原始文件（追蹤 Token 已遮蔽）</summary>
                  <pre>{formatRawDocument(detailRecord)}</pre>
                </details>
              </div>
            </details>
          </div>
        ) : null}
      </div>
    </main>
  );
}
